import { Box } from '@mui/material';

export const Physiotheaphy = () => {
    return <Box sx={{ flex: 1 }}></Box>;
};
